import { Button, Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useBoundStore } from 'useStore';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';

function DetailCard({ row }) {
	const openPricingCostHistoryModal = useBoundStore(
		(state) => state.openPricingCostHistoryModal
	);

	const handleOpen = () => {
		openPricingCostHistoryModal(row);
	};

	return (
		<Paper
			sx={{
				width: '250px',
				borderRadius: '0px',
				p: '10px',
			}}
		>
			<Stack>
				<Stack direction="row" spacing={1}>
					<Typography>PO:</Typography>
					<Typography>{row?.po}</Typography>
				</Stack>
				<Stack direction="row" spacing={1}>
					<Typography>Embarque:</Typography>
					<Typography>{row?.embarque}</Typography>
				</Stack>
				<Stack direction="row" spacing={1}>
					<Typography>Costo:</Typography>
					<Typography>{row?.costo}</Typography>
				</Stack>
				<Stack direction="row" spacing={1}>
					<Typography>Fecha de embarque:</Typography>
					<Typography>
						{row?.fechaembarque
							? new Date(row?.fechaembarque).toLocaleDateString()
							: ''}
					</Typography>
				</Stack>

				<Button onClick={handleOpen}>Mas detalles</Button>
			</Stack>
		</Paper>
	);
}

export default function CostTooltipCard({ children, row }) {
	return (
		<LightTooltip title={<DetailCard row={row} />}>{children}</LightTooltip>
	);
}
